export const ACTION_NAMES = {
  RENDER: 'render',
} as const;

export const CONTEXT_NAMES = {
  COMPONENT_ID: 'component_id',
  PHASE: 'phase', // either "mount" (if the tree just mounted) or "update" (if it re-rendered)
  ACTUAL_DURATION: 'actual_duration', // time spent rendering the committed update
  BASE_DURATION: 'base_duration', // estimated time to render the entire subtree without memoization
  START_TIME: 'start_time', // when React began rendering this update
  COMMIT_TIME: 'commit_time', // when React committed this update
  TRADING_ENTITY: 'trading_entity',
  TRADING_ACTION: 'trading_action',
  CL_ORD_ID: 'cl_ord_id',
  ORDER_ID: 'order_id',
} as const;
